import { styled } from '@linaria/react';

import ControlWrapper from '@/components/Controls/ControlWrapper';

import ModeToggle from './ModeToggle';
import {
  VALID_COLOR_MODES,
  ColorMode,
} from './GradientGenerator.helpers';

interface Props {
  id: string;
  colorMode: ColorMode;
  setColorMode: (mode: ColorMode) => void;
}

function ModeControl({ id, colorMode, setColorMode }: Props) {
  return (
    <ControlWrapper id={id} label="Color Mode" labelAs="span">
      <ModeList>
        {VALID_COLOR_MODES.map((mode) => {
          return (
            <ModeToggle
              key={mode}
              name="color-mode"
              checked={mode === colorMode}
              onToggle={() => setColorMode(mode)}
              style={{ flex: 1 }}
            >
              {mode.toUpperCase()}
            </ModeToggle>
          );
        })}
      </ModeList>
    </ControlWrapper>
  );
}

const ModeList = styled.ul`
  display: flex;
  gap: 16px;
  list-style-type: none;
  padding: 0;
`;

export default ModeControl;
